import axios from 'axios'
import { IResBase } from '../base'
import { IGetSendSmsResponse } from './Models/GetSendSmsResponse'
import { IGetTokenDto } from './Models/GetTokenDto'
import { IGetTokenResponse } from './Models/GetTokenResponse'
import { IGetSmsReportResponse } from './Models/GetSmsReportResponse'
import { ISendSmsDto } from './Models/SendSmsDto'
import { IGetConfirmationCodeResponse, IVerifyConfirmationCodeResponse } from './Models/GetConfirmationCodeResponse'

export const smsService = () => {
  const baseUrl = 'http://31.25.90.107:1500'

  const getSendSmsAsync = async (clinicId: number | null, officeId: number) => {
    const response = await axios.get<IResBase<IGetSendSmsResponse[]>>('Sms/GetSendSms', { params: { clinicId, officeId } })
    return response.data
  }

  const getTokenAsync = async (getTokenDto: IGetTokenDto) => {
    const response = await axios.post<IGetTokenDto, any>('Sms/GetToken', getTokenDto)
    return response.data
  }

  const getSmsReportAsync = async (clinicId: number | null, officeId: number) => {
    const response = await axios.get<IResBase<IGetSmsReportResponse>>('Sms/GetSmsReport', { params: { clinicId, officeId } })
    return response.data
  }

  const sendSmsAsync = async (sendSmsDto: ISendSmsDto) => {
    const response = await axios.post('Sms/SendSms', sendSmsDto)
    return response.data
  }

  //TODO
  const chargeSmsAccountAsync = async (getTokenDto: IGetTokenDto, amount: number) => {
    const token = await getTokenAsync(getTokenDto)
    // Process.Start($"{baseUrl}/payment/ChargeSmSAccount?amount={amount}&utoken={token.Token}");
  }

  const getConfirmationCode = async (username: string) => {
    const result = await axios.post<IResBase<IGetConfirmationCodeResponse>>('Sms/SendConfirmationCode', {
      username: username,
    })
    return result.data
  }
  
  const getConfirmationCodeAnonymous = async (mobile: string) => {
    const result = await axios.post<IResBase<any>>('Sms/SendConfirmationCode/Anonymous', {
      mobile,
    })
    return result.data
  }

  const VerifyAnonymousConfirmationCode = async (mobile: string,confirmationCode:string) => {
    const result = await axios.post<IResBase<IVerifyConfirmationCodeResponse>>('Sms/VerifyAnonymousConfirmationCode', {
      mobile,confirmationCode
    })
    return result.data
  }

  return {
    getSendSmsAsync,
    getTokenAsync,
    getSmsReportAsync,
    sendSmsAsync,
    getConfirmationCode,
    getConfirmationCodeAnonymous,
    VerifyAnonymousConfirmationCode
  }
}
